import React from 'react';
import { ArrowUpRightIcon, QuoteIcon } from 'lucide-react';
export interface Testimonial {
  name: string;
  role: string;
  text: string;
  avatar?: string;
}
interface TestimonialsSectionProps {
  title?: string;
  subtitle?: string;
  badgeText?: string;
  testimonials: Testimonial[];
}
export function TestimonialsSection({
  title = 'Escenarios que una presencia bien resuelta puede transformar',
  subtitle = 'Referencias ilustrativas del tipo de claridad, acompañamiento y experiencia que buscamos construir. No son testimonios verificables.',
  badgeText = 'Referencias ilustrativas',
  testimonials
}: TestimonialsSectionProps) {
  return <section id="testimonials" className="section-shell border-t border-white/10 bg-black" aria-labelledby="testimonials-title" data-id="element-172" data-mp="91fv0rxuhez7">
      <div className="container mx-auto px-6 md:px-12" data-id="element-173" data-mp="3cooii7h3ghds">
        <div className="grid gap-7 border-b border-white/10 pb-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-end" data-id="element-174" data-mp="3cn528gvfu6c0">
          <div data-id="element-175" data-mp="37oalrlky0tv2">
            <p className="eyebrow" data-id="element-176" data-mp="3tkgfk21s4uk">{badgeText}</p>
            <h2 id="testimonials-title" className="mt-5 text-3xl font-medium tracking-[-0.045em] text-white sm:text-4xl" data-id="element-177" data-mp="3ssvr49znrj2">
              {title}
            </h2>
          </div>
          <p className="max-w-2xl text-sm leading-relaxed text-neutral-400 sm:text-base" data-id="element-178" data-mp="dl8ei3t40k50">
            {subtitle}
          </p>
        </div>
        <div className="grid gap-5 pt-10 lg:grid-cols-2" data-id="element-179" data-mp="3h0du959eu0en">
          {testimonials.map((testimonial, index) => <article key={`${testimonial.name}-${index}`} className="flex min-h-[250px] flex-col border border-white/10 bg-[#0a0a0a] p-7 sm:p-8" data-id="element-180" data-mp="3ly5ow71fw0mj" data-mpi={index}>
              <div className="flex items-start justify-between" data-id="element-181" data-mp="3v056p1ka38qj">
                <QuoteIcon size={20} className="text-white" aria-hidden="true" data-id="element-182" data-mp="3ux9778ss8bzz" />
                <span className="text-[10px] font-medium tracking-[0.2em] text-neutral-600" data-id="element-183" data-mp="1a8d46b5wa5wa">
                  0{index + 1}
                </span>
              </div>
              <p className="mt-10 text-lg leading-relaxed tracking-[-0.02em] text-neutral-200" data-id="element-184" data-mp="32b7m44607dmp">
                “{testimonial.text}”
              </p>
              <footer className="mt-auto flex items-end justify-between border-t border-white/10 pt-6" data-id="element-185" data-mp="3ga726nfgak79">
                <div data-id="element-186" data-mp="3bcf8bnv8wo0f">
                  <p className="text-sm font-medium text-white" data-id="element-187" data-mp="3b9t4nzbh6snh">
                    {testimonial.name}
                  </p>
                  <p className="mt-1 text-xs text-neutral-500" data-id="element-188" data-mp="2ingp0nfdzftj">
                    {testimonial.role}
                  </p>
                </div>
                <ArrowUpRightIcon size={16} className="text-neutral-600" aria-hidden="true" data-id="element-189" data-mp="2xd5swqev5xxi" />
              </footer>
            </article>)}
        </div>
      </div>
    </section>;
}